const fr = {
  // Coach Landing Page (New Home)
  coachLanding: {
    tagline: 'La plateforme qui connecte les coachs sportifs aux sportifs de leur quartier',
    discoverMotivya: 'Découvrir Motivya',
    // Animated Pitch Scenes
    scene1Text: 'Vous êtes coach ou préparateur physique ?',
    scene1Subtext: 'Bruxelles a besoin de vous',
    scene2Text: 'Marre de chercher des clients ?',
    scene2Subtext: 'Fini la paperasse et l\'administratif',
    scene3Text: 'Vous avez 4h par semaine ou plus ?',
    scene3Subtext: 'Générez des revenus supplémentaires',
    scene4Text: 'Vous planifiez, Motivya fait le reste',
    scene4Subtext: 'Les participants viennent automatiquement',
    scene5Text: 'Focus sur votre passion',
    scene5Subtext: 'Zéro paperasse • Clients automatiques • Impact local',
    selectedBadge: 'Vous êtes sélectionné pour devenir Ambassadeur',
    ambassadorSpots: 'places d\'ambassadeurs',
    inBrussels: 'à Bruxelles',
    reservedSpots: 'Places réservées',
    onlyRemaining: 'Plus que {count} places disponibles !',
    ctaButton: 'Devenir Coach Ambassadeur',
    discoverMore: 'Découvrir les avantages',
    whyJoin: 'Pourquoi rejoindre Motivya ?',
    advantagesTitle: 'Tous les avantages d\'être coach ambassadeur',
    advantagesSubtitle: 'Rejoignez les 90 premiers coachs fondateurs et bénéficiez d\'avantages exclusifs à vie',
    zeroRisk: 'Zéro risque',
    zeroRiskDesc: 'Vous définissez un seuil minimum de participants. Si non atteint, la séance est annulée sans frais.',
    commissionHalved: 'Commission ÷ 2',
    commissionHalvedDesc: 'En tant qu\'ambassadeur, votre commission est divisée par 2 à vie (10% au lieu de 20%).',
    clientsProvided: 'Clients fournis',
    clientsProvidedDesc: 'Motivya diffuse vos séances aux sportifs de votre zone. Les clients viennent à vous.',
    flexibleSchedule: 'Horaires flexibles',
    flexibleScheduleDesc: 'Créez vos séances quand et où vous voulez. Vous êtes votre propre patron.',
    guaranteedIncome: 'Revenus garantis',
    guaranteedIncomeDesc: 'Paiement automatique après chaque séance. Pas de facturation, pas d\'administratif.',
    founderStatus: 'Statut Fondateur',
    founderStatusDesc: 'Visibilité maximale dès le lancement. Les premiers créneaux sont pour vous.',
    howItWorksTitle: 'Comment ça marche ?',
    step1Title: 'Créez votre profil',
    step1Desc: 'En 2 minutes, présentez vos spécialités et votre expérience.',
    step2Title: 'Publiez vos séances',
    step2Desc: 'Définissez lieu, horaire, prix et nombre minimum de participants.',
    step3Title: 'Recevez vos paiements',
    step3Desc: 'Les réservations arrivent, la séance a lieu, vous êtes payé automatiquement.',
    finalCtaTitle: 'Prêt à lancer votre activité ?',
    finalCtaSubtitle: 'Rejoignez les coachs fondateurs de Motivya et développez votre clientèle sans effort.',
    freeNoCommitment: 'Inscription gratuite • Sans engagement • Validation sous 48h',
  },

  // Navigation
  nav: {
    explore: 'Explorer',
    becomeCoach: 'Devenir Coach',
    login: 'Connexion',
    register: 'Commencer',
    dashboard: 'Dashboard',
    admin: 'Admin',
    logout: 'Déconnexion',
    coach: 'Coach',
    profile: 'Profil',
    favorites: 'Favoris',
    outfit: 'Tenue',
  },

  // Sessions
  sessions: {
    join: "Je m'inscris",
    viewAll: 'Voir toutes les séances',
    viewCoachSessions: 'Voir ses séances',
  },

  // Landing Page
  landing: {
    // New hero messaging
    heroTitle: 'Le sport dans votre quartier commence ici.',
    heroSub: 'Découvrez et rejoignez',
    intention: 'les activités sportives',
    in: 'autour',
    action: 'de vous',
    heroDesc: 'Rejoignez des séances sportives près de chez vous, aujourd\'hui.',
    searchPlaceholder: 'Où voulez-vous bouger ?',
    search: 'Rechercher',
    nearMe: 'Trouver une séance',
    allActivities: 'Explorer toutes les activités',
    sessionsStartingIn3h: 'séances dans les 3 prochaines heures à',
    startingSoonTitle: 'Ça commence bientôt près de vous',
    sessions: 'Séances',
    coaches: 'Coachs',
    avgRating: 'Note moyenne',
    // Activities nearby section
    nearbyTitle: 'Activités près de vous',
    nearbySubtitle: 'Rejoignez une séance maintenant',
    joinSession: 'Rejoindre la séance',
    participants: 'participants',
    peopleParticipating: 'personnes participent déjà',
    // Weekly sessions section
    weeklyTitle: 'Rendez-vous sportifs de la semaine',
    weeklySubtitle: 'Créez votre routine hebdomadaire',
    everyWednesday: 'Tous les mercredis',
    everySaturday: 'Tous les samedis',
    everySunday: 'Tous les dimanches',
    participateThisWeek: 'Participer cette semaine',
    // Category section
    findActivity: 'Ce qui se passe',
    activity: 'près de vous aujourd\'hui',
    findActivityDesc: 'Du yoga matinal au renforcement intensif, découvrez des activités qui vous correspondent',
    allActivities: 'Voir toutes les activités',
    // Features section
    whyMotivya: 'Pourquoi',
    whyMotivyaDesc: 'Motivya rassemble les coachs et les sportifs de votre quartier.',
    // Coach section
    youAreCoach: 'Vous êtes',
    coachWord: 'Coach',
    coachSubtitle: 'Développez votre communauté sportive locale.',
    coachSubtext: 'Attirez des participants près de chez vous et remplissez vos séances.',
    becomePartner: 'Devenir Coach Partenaire',
    coachBlock1Title: 'Revenus récurrents',
    coachBlock1Text: 'De nouveaux revenus récurrents, sans complexité.',
    coachBlock2Title: 'Clients de proximité',
    coachBlock2Text: 'Des clients tout près. Moins de trajets, plus de séances.',
    coachBlock3Title: 'Zéro séance à perte',
    coachBlock3Text: 'Seuil d\'inscrits atteint = séance confirmée.',
    // Social proof
    socialProof: 'Déjà des centaines de séances organisées à Bruxelles.',
    // Dynamic stats
    totalParticipants: 'Participants',
    coachesIn: 'Coachs à',
    sessionsThisWeek: 'Séances cette semaine',
    joinCommunity: 'Rejoindre la communauté',
    // Real-time indicators
    sessionsStartingIn3h: 'séances commencent dans les 3 prochaines heures à',
    participantsToday: 'sportifs participent à des séances aujourd\'hui',
    // Starting soon section
    urgentLabel: 'Ça commence bientôt !',
    startingSoonTitle: 'Les séances qui commencent bientôt',
    startingSoonSubtitle: 'Ne manquez pas ces activités qui démarrent dans les prochaines heures',
    startsIn: 'Commence dans',
    today: 'Aujourd\'hui',
    // Featured coaches section
    coachesNearbyTitle: 'Les coachs de votre quartier',
    coachesNearbySubtitle: 'Découvrez les coachs actifs près de chez vous',
    sessionsOrganized: 'séances',
    totalParticipantsCoach: 'participants',
    viewCoachSessions: 'Voir ses séances',
    // Communities section
    communitiesTitle: 'Les communautés sportives de Bruxelles',
    communitiesSubtitle: 'Rejoignez un groupe et pratiquez régulièrement',
    members: 'membres',
    joinCommunityBtn: 'Rejoindre la communauté',
    joinedCommunity: 'Vous avez rejoint la communauté !',
    // Map section
    activitiesAroundYou: 'Activités autour de vous',
    filterToday: "Aujourd'hui",
    filterTonight: 'Ce soir',
    filterWeek: 'Cette semaine',
    filterNearby: 'Près de moi',
    mapRadiusInfo: 'Cercle de 2 km autour de votre position • Cliquez sur "Me localiser" sur la carte pour centrer',
    // Popular activities
    popularActivities: 'Activités populaires',
    // Coaches section
    neighborhoodCoaches: 'Coachs du quartier',
    activeCoachesNear: 'Les coachs actifs près de',
    allCoaches: 'Tous les coachs',
    viewSessions: 'Voir ses séances',
    // Communities section
    sportsCommunities: 'Communautés sportives',
    joinGroupRegularly: 'Rejoignez des groupes locaux pour pratiquer régulièrement',
    joinGroup: 'Rejoindre le groupe',
    // Coach CTA section
    developCommunity: 'Développez votre communauté sportive locale',
    joinMotivy: 'Rejoignez Motivya et transformez votre passion en activité florissante',
    fillSessions: 'Remplissez vos séances',
    findNearbyAthletes: 'Trouvez des sportifs près de chez vous',
    createRecurringIncome: 'Créez des revenus récurrents',
    becomePartnerCoach: 'Devenir coach partenaire',
    // Stats section
    activeParticipants: 'Participants actifs',
    certifiedCoaches: 'Coachs certifiés',
    sessionsThisWeekLabel: 'Séances cette semaine',
    coveredMunicipalities: 'Communes couvertes',
    // Newsletter section
    receiveSessionsNearYou: 'Recevez les séances près de chez vous',
    beNotifiedNewSessions: 'Soyez notifié des nouvelles séances dans votre quartier',
    yourEmail: 'Votre email',
    subscribeBtn: "S'inscrire",
    thankYouSubscribed: 'Merci ! Vous êtes inscrit.',
    // Footer
    footerExplore: 'Explorer',
    footerRegister: 'S\'inscrire',
    footerCoach: 'Devenir Coach',
    footerActivities: 'Activités',
    footerLegal: 'Légal',
    footerPrivacy: 'Confidentialité',
    footerTerms: 'CGU',
    footerContact: 'Contact',
    footerLocation: 'Bruxelles, Belgique',
    footerSlogan: 'Le sport dans votre quartier',
    allRightsReserved: 'Tous droits réservés.',
  },

  // Community subscription
  community: {
    title: 'Rejoignez la communauté Motivya',
    subtitle: 'Recevez les nouvelles séances près de chez vous selon vos préférences sportives.',
    emailPlaceholder: 'Votre adresse email',
    subscribe: 'S\'inscrire',
    selectPreferences: 'Choisissez vos activités préférées (optionnel)',
    privacyNote: 'Nous respectons votre vie privée. Désabonnement possible à tout moment.',
    subscribed: 'Bienvenue dans la communauté !',
    subscribedDesc: 'Vous recevrez bientôt les meilleures séances près de chez vous.',
    subscribeSuccess: 'Inscription réussie ! Bienvenue dans la communauté Motivya.',
    subscribeError: 'Erreur lors de l\'inscription. Veuillez réessayer.',
    emailRequired: 'Veuillez entrer votre adresse email.',
  },

  // Features
  features: {
    quickBooking: 'Réservation Éclair',
    quickBookingDesc: '2-3 clics et c\'est réservé. Simple. Rapide. Efficace.',
    nearby: 'Proximité',
    nearbyDesc: 'Trouvez des activités à deux pas de chez vous grâce à la géolocalisation.',
    trust: 'Confiance',
    trustDesc: 'Coachs certifiés et évalués par une communauté engagée.',
    flexibility: 'Flexibilité',
    flexibilityDesc: 'Sessions régulières ou événementielles, selon vos envies.',
  },

  // Categories
  categories: {
    all: 'Toutes',
    yoga: 'Yoga',
    renforcement: 'Renforcement',
    mobilite: 'Mobilité',
    outdoor: 'Outdoor',
    running: 'Running',
    cardio: 'Cardio',
    pilates: 'Pilates',
    boxe: 'Boxe',
    danse: 'Danse',
    padel: 'Cours de Padel',
    tennis: 'Cours de Tennis',
  },

  // Explore Page
  explore: {
    objectiveTitle: 'Quel est votre objectif aujourd\'hui ?',
    personalize: 'Personnaliser mon expérience',
    findActivity: 'Trouvez votre activité',
    cityPlaceholder: 'Ville ou code postal (ex: 1050, Ixelles, Schaerbeek...)',
    category: 'Catégorie',
    level: 'Niveau',
    priceMax: 'Prix max (€)',
    clear: 'Effacer',
    apply: 'Appliquer',
    loading: 'Chargement...',
    sessions: 'séances',
    session: 'séance',
    resetFilters: 'Réinitialiser filtres',
    noResults: 'Aucune séance trouvée',
    noResultsDesc: 'Essayez de modifier vos critères de recherche',
    clearFilters: 'Effacer les filtres',
    showing: 'Affichage des 50 premières séances sur',
    confirmed: 'Confirmé',
    pending: 'En attente',
    event: 'Événement',
    book: 'Réserver',
    min: 'min',
    filteringByCoach: 'Séances de',
  },

  // Timing
  timing: {
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    thisWeek: 'Cette semaine',
    thisWeekend: 'Ce weekend',
    all: 'Toutes',
    filterByDate: 'Filtrer par date',
    inMinutes: 'Dans {{min}} min',
    inOneHour: 'Dans 1h{{min}}',
    inHours: 'Dans {{hours}}h{{min}}',
  },

  // Levels
  levels: {
    all: 'Tous niveaux',
    debutant: 'Débutant',
    intermediaire: 'Intermédiaire',
    avance: 'Avancé',
    tous: 'Tous niveaux',
  },

  // Objectives
  objectives: {
    douceur: 'Reprendre en douceur',
    douceurDesc: 'Activités douces pour recommencer le sport en toute sérénité',
    regulier: 'Bouger régulièrement',
    regulierDesc: 'Un mix varié pour maintenir une routine équilibrée',
    challenge: 'Me challenger',
    challengeDesc: 'Séances intenses pour repousser vos limites',
    jeune: 'Progresser jeune',
    jeuneDesc: 'Énergie et dynamisme pour les plus motivés',
    senior: 'Rester actif 50+',
    seniorDesc: 'Activités adaptées pour une forme durable',
    clickToChange: 'Cliquez pour changer',
  },

  // Onboarding
  onboarding: {
    welcome: 'Bienvenue sur Motivya !',
    welcomeDesc: 'Trouvez des activités sportives près de chez vous, adaptées à vos objectifs et à votre niveau.',
    sessionsCount: '200+ séances',
    nearYou: 'Près de vous',
    certifiedCoaches: 'Coachs certifiés',
    start: 'Commencer',
    objectiveTitle: 'Quel est votre objectif ?',
    objectiveDesc: 'On personnalise vos recommandations',
    back: 'Retour',
    discover: 'Découvrir les activités',
    locating: 'Localisation...',
    locationNote: 'Nous utiliserons votre position pour trouver les activités près de vous',
  },

  // Become Coach Page
  coach: {
    noRiskModel: 'Modèle sans risque financier',
    heroTitle1: 'Générez des revenus réguliers.',
    heroTitle2: 'Sans risque. Sans salle.',
    heroSub1: 'Vous fixez votre prix. Vous fixez votre seuil minimum.',
    heroSub2: 'Le cours ne s\'active que s\'il est rentable.',
    simulateRevenue: 'Simuler mes revenus',
    createProfile: 'Créer mon profil coach',
    keyPrinciple: 'Principe clé',
    neverAtLoss: 'Jamais à perte.',
    neverAtLossDesc: 'Le concept qui change tout pour les coachs indépendants',
    defineThreshold: 'Définissez votre seuil',
    defineThresholdDesc: 'Vous choisissez le nombre minimum de participants (ex: 4 personnes) pour que la séance soit rentable.',
    thresholdReached: 'Seuil atteint = Séance confirmée',
    thresholdReachedDesc: 'Si le minimum est atteint, la séance est automatiquement confirmée. Vous enseignez, vous gagnez.',
    thresholdNotReached: 'Seuil non atteint = Annulation automatique',
    thresholdNotReachedDesc: 'Pas assez d\'inscrits ? La séance est annulée automatiquement. Les participants sont remboursés. Vous ne vous déplacez pas.',
    zeroLoss: 'Zéro perte garantie',
    zeroLossDesc: 'Aucun déplacement inutile. Aucun cours déficitaire. Votre temps et votre énergie sont protégés.',
    concreteExample: 'Exemple concret',
    pricePerParticipant: 'Prix par participant',
    minThreshold: 'Seuil minimum',
    participants: 'participants',
    grossRevenue: 'Revenu brut',
    yourReturn: 'Votre revenu complémentaire',
    guaranteedSession: 'Séance garantie rentable',
    returnRange: 'entre 42€ et 54€ selon votre statut Motivya',
    calculateReturn: 'Calculez votre revenu complémentaire',
    adjustParams: 'Ajustez les paramètres et sélectionnez votre plan pour voir vos gains après commission',
    revenueSimulator: 'Simulateur de revenus',
    estimateReturn: 'Estimez votre revenu complémentaire mensuel',
    pricePerPerson: 'Prix par participant',
    minParticipants: 'Seuil minimum de participants',
    avgParticipants: 'Participants moyens par séance',
    sessionsPerMonth: 'Séances par mois',
    plan: 'Plan',
    commission: 'commission',
    monthlySubscription: 'Abonnement mensuel',
    guaranteed: 'REVENU MINIMUM INDICATIF',
    average: 'REVENU MOYEN',
    potential: 'REVENU POTENTIEL',
    minMonth: 'indicatif/mois',
    estMonth: 'estimé/mois',
    optMonth: 'optimisé/mois',
    calcDetail: 'Détail du calcul (revenu moyen) :',
    grossRev: 'Revenu brut',
    paymentFees: 'Frais de paiement (1,5%)',
    commissionMotivya: 'Commission Motivya',
    subscription: 'Abonnement',
    complementaryReturn: 'Revenu complémentaire',
    paymentNote: 'Frais de paiement : Stripe, PayPal, Bancontact (1,5%)',
    chooseFormula: 'Choisissez votre formule',
    pricingTitle: 'Des tarifs adaptés à votre activité',
    pricingDesc: 'Plus vous vous engagez, moins vous payez de commission',
    popular: 'POPULAIRE',
    month: '/mois',
    selected: '✓ Sélectionné',
    subscribeTo: 'Souscrire à',
    entrepreneurTitle: 'Gérez votre activité comme un entrepreneur',
    entrepreneurDesc: 'Tous les outils pour développer votre business de coaching',
    setPrices: 'Fixez vos prix',
    setPricesDesc: 'Vous décidez de vos tarifs selon votre expérience et votre marché',
    chooseLocations: 'Choisissez vos lieux',
    chooseLocationsDesc: 'Parcs, plages, espaces publics... Enseignez où vous voulez',
    profitThreshold: 'Seuil de rentabilité',
    profitThresholdDesc: 'Définissez le minimum de participants pour chaque séance',
    securePayment: 'Paiement sécurisé',
    securePaymentDesc: 'Les participants paient à l\'avance. Vous êtes payé automatiquement',
    totalFlexibility: 'Flexibilité totale',
    totalFlexibilityDesc: 'Créez, modifiez ou annulez vos séances en quelques clics',
    zeroAdmin: 'Zéro admin',
    zeroAdminDesc: 'Facturation, remboursements, notifications... tout est automatisé',
    quote: '"Vous enseignez. Motivya sécurise votre rentabilité."',
    readyTitle: 'Prêt à développer votre activité sans risque ?',
    readyDesc: 'Rejoignez les coachs qui ont choisi la sécurité financière',
    alreadyCoach: 'Vous êtes déjà coach !',
    accessDashboard: 'Accédez à votre tableau de bord pour gérer vos séances',
    goToDashboard: 'Accéder au dashboard coach',
    applicationPending: 'Candidature en cours d\'examen',
    applicationPendingDesc: 'Votre candidature a été soumise avec succès ! L\'équipe Motivya l\'examine actuellement et vous contactera bientôt.',
    processingTime: 'Délai de traitement habituel : 24-48h ouvrées',
    backHome: 'Retour à l\'accueil',
    applicationRejected: 'Candidature non retenue',
    applicationRejectedDesc: 'Malheureusement, votre candidature n\'a pas été retenue cette fois.',
    rejectionReason: 'Raison :',
    reapplyNote: 'Vous pouvez soumettre une nouvelle candidature après 30 jours.',
    // Application form
    applicationTitle: 'Candidature Coach',
    step: 'Étape',
    contactInfo: 'Informations de contact',
    contactInfoDesc: 'Comment pouvons-nous vous joindre ?',
    profilePhoto: 'Photo de profil',
    uploadPhoto: 'Télécharger une photo',
    photoHint: 'JPG ou PNG, max 5MB. Votre photo apparaîtra sur votre profil.',
    photoUploaded: 'Photo téléchargée avec succès !',
    photoUploadError: 'Erreur lors du téléchargement de la photo',
    photoInvalidType: 'Veuillez sélectionner une image (JPG, PNG)',
    photoTooLarge: 'La photo ne doit pas dépasser 5MB',
    phone: 'Téléphone',
    professionalEmail: 'Email professionnel',
    mainLocation: 'Localisation principale',
    linkedin: 'Profil LinkedIn',
    website: 'Site web',
    continue: 'Continuer',
    proProfile: 'Profil professionnel',
    proProfileDesc: 'Parlez-nous de votre expérience',
    presentation: 'Votre présentation',
    presentationPlaceholder: 'Décrivez votre parcours, votre approche et ce qui vous différencie...',
    experienceYears: 'Années d\'expérience',
    specialties: 'Spécialités',
    selectOneMin: '(sélectionnez au moins une)',
    certifications: 'Certifications / Diplômes',
    addCertification: '+ Ajouter une certification',
    motivationTitle: 'Votre motivation',
    lastStep: 'Dernière étape avant soumission',
    whyJoin: 'Pourquoi rejoindre Motivya ?',
    motivationPlaceholder: 'Expliquez vos motivations, vos objectifs et ce que vous attendez de la plateforme...',
    summary: 'Récapitulatif',
    location: 'Localisation',
    experience: 'Expérience',
    years: 'ans',
    chosenPlan: 'Plan choisi',
    submitting: 'Envoi en cours...',
    submit: 'Soumettre ma candidature',
    submitDisclaimer: 'En soumettant ce formulaire, vous acceptez que vos informations soient examinées par l\'équipe Motivya.',
    applicationSent: 'Candidature envoyée !',
    applicationSentDesc: 'Merci pour votre candidature ! L\'équipe Motivya l\'examinera dans les 24-48h et vous contactera par email.',
    // Pricing features
    publishSessions: 'Publication de séances',
    manageBookings: 'Gestion des réservations',
    securePaymentFeature: 'Paiement sécurisé',
    basicStats: 'Statistiques de base',
    prioritySupport: 'Support prioritaire',
    searchVisibility: 'Mise en avant dans les recherches',
    premiumBadge: 'Badge "Coach Premium"',
    advancedAnalytics: 'Analytics avancés',
    startFree: 'Commencer gratuitement',
    chooseActive: 'Choisir Active',
    choosePremium: 'Choisir Premium',
    // Simulator lock
    simulatorLocked: 'Simulateur verrouillé',
    simulatorLockedDesc: 'Créez un compte gratuit pour accéder au simulateur de revenus et découvrir votre potentiel de gains.',
    simulatorLockedDescCoach: 'Le simulateur est réservé aux coachs validés. Inscrivez-vous et réservez votre appel de validation.',
    createAccount: 'Créer un compte gratuit',
    alreadyHaveAccount: 'Déjà un compte ?',
    iAmCoach: 'Je suis coach',
    iAmPractitioner: 'Je suis pratiquant',
    // Simplified acquisition form
    socialProof: '+100 coachs nous font déjà confiance',
    joinCommunity: 'Rejoignez la communauté',
    in30Seconds: 'En 3 clics, réservez votre appel de validation',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    bookValidationCall: 'Réserver mon appel de validation',
    call10min: 'Appel de 10 min avec notre équipe',
    profileValidation: 'Validation de votre profil coach',
    fullAccess: 'Accès à votre espace coach complet',
    alreadyAccount: 'Déjà inscrit ?',
    loginHere: 'Connectez-vous',
    thankYou: 'Merci !',
    bookCallNow: 'Réservez maintenant votre appel de validation avec notre équipe.',
    bookMyCall: 'Réserver mon appel',
    calendlyNote: 'Vous serez redirigé vers Calendly',
    fillAllFields: 'Veuillez remplir tous les champs',
    invalidEmail: 'Adresse email invalide',
    leadSaved: 'Informations enregistrées !',
    // Ambassador page
    launchInProgress: 'Lancement en cours',
    foundingCoachTitle: 'Devenez l\'un des 90 coachs fondateurs à Bruxelles',
    foundingCoachSubtitle: 'Rejoignez le programme ambassadeur et bénéficiez d\'avantages exclusifs à vie',
    becomeAmbassador: 'Devenir coach ambassadeur',
    alreadyJoined: 'Déjà {count} coachs nous ont rejoint',
    joinAdventure: 'Fais partie de l\'aventure en tant qu\'ambassadeur',
    opportunityTitle: 'Les premiers arrivés, les mieux servis',
    opportunityDesc: 'Les 90 premiers coachs à rejoindre Motivya à Bruxelles bénéficient du statut de Coach Fondateur avec des avantages exclusifs à vie.',
    noRiskTitle: 'Jamais à perte',
    noRiskDesc: 'Vous fixez votre seuil minimum. Si ce seuil n\'est pas atteint, la séance est annulée automatiquement.',
    commissionDivided: 'Commission ÷ 2',
    whileActive: 'Tant que vous êtes actif (hors Freemium)',
    founderBadge: 'Badge Coach Fondateur',
    badgeForLife: 'Affiché sur votre profil à vie',
    priorityVisibility: 'Visibilité prioritaire',
    topSearchResults: 'En haut des résultats de recherche',
    earlyAccess: 'Accès anticipé',
    newFeatures: 'Aux nouvelles fonctionnalités',
    productInfluence: 'Influence produit',
    participateDecisions: 'Participez aux décisions',
    guaranteedReturn: '100% retour garanti',
    autoAdjust: 'Votre choix d\'abonnement s\'ajuste automatiquement pour que votre activité soit optimale.',
    autoUpgrade: 'Si la formule Premium devient plus avantageuse pour vous, nous adaptons automatiquement votre facturation pour que vous soyez toujours récompensé de vos performances.',
    noPrePayment: 'Pas de pré-paiement d\'abonnement en tant qu\'ambassadeur, les frais sont débités lors de la première facturation. Zéro risque.',
    readyGo: 'Ready? Go...',
    howItWorks: 'Comment ça marche',
    step1Title: 'Créez votre profil',
    step1Desc: 'Inscrivez-vous et complétez votre fiche coach en 5 minutes',
    step2Title: 'Publiez vos séances',
    step2Desc: 'Créez vos activités avec vos tarifs et votre seuil minimum',
    step3Title: 'Recevez vos participants',
    step3Desc: 'Motivya promeut vos séances et gère les inscriptions automatiquement',
    limitedOffer: 'Offre limitée',
    ambassadorSpots: '90 places d\'ambassadeurs pour Bruxelles',
    commissionHalved: 'commission divisée par 2',
    freemiumStays: 'Le Freemium reste à 30% sans changement.',
    plusPaymentFees: '(+ frais de paiement 1,5%)',
    reserveSpot: 'Réserver ma place d\'ambassadeur',
    takeAdvantage: 'Prenez une longueur d\'avance',
    rightNow: 'dès maintenant',
    joinCoaches: 'Rejoignez les {count} coachs qui ont déjà réservé leur place',
    spotsRemaining: 'Rejoignez les {remaining} places restantes',
    createYourProfile: 'Créez votre profil',
    ambassadorProgram: 'Programme Coach Ambassadeur',
    journeySimulator: 'Simulateur Interactif',
    liveExperience: 'Vivez l\'expérience coach',
    discoverIn30s: 'Découvrez comment fonctionne Motivya en 3 clics',
    createTestSession: 'Créer une séance test',
    clickToSeeMagic: 'Cliquez pour voir la magie opérer ✨',
    creation: 'Création',
    promotion: 'Promotion',
    reservations: 'Réservations',
    thresholdReachedStep: 'Seuil atteint',
    payment: 'Paiement',
    sessionCreated: '✨ Séance créée !',
    promotionInProgress: '📣 Promotion en cours...',
    promotingSession: 'Motivya diffuse votre séance aux sportifs de votre zone',
    registrationsArriving: '👥 Les inscriptions arrivent !',
    minThreshold: 'Seuil minimum : {count} participants',
    thresholdReached: '🎉 Seuil atteint !',
    sessionConfirmed: 'Votre séance est confirmée',
    participantsRegistered: '{count} participants inscrits',
    didNothing: '❤️ Vous n\'avez rien eu à faire !',
    paymentReceived: '💰 Paiement reçu !',
    coachActive: 'Coach Active',
    coachAmbassador: 'Coach Ambassadeur',
    asAmbassador: 'en tant qu\'ambassadeur',
    invoicesGenerated: 'Factures générées automatiquement',
    replayDemo: 'Rejouer la démo',
    sessionBooked: 'Séance réservée. Séance donnée. Séance payée.',
    focusOnPassion: 'Concentrez-vous sur votre passion, Motivya gère le reste.',
    exVAT: 'Hors TVA',
    commissionMotivya: 'Commission Motivya',
    transactionFees: 'Frais de transaction',
    transactionFeesNote: '(indicatif, optimisé selon les moyens de paiement)',
    // Additional keys for full translation
    reservedSpots: 'Places réservées',
    simulateRevenue: 'Simulez vos revenus en 3 clics',
    adjustParameters: 'Ajustez les paramètres selon votre activité',
    pricePerParticipant: 'Prix par participant',
    minThresholdLabel: 'Seuil minimum de participants',
    sessionsPerMonth: 'Séances par mois',
    monthlyNetRevenue: 'Revenu additionnel mensuel',
    yearlyProjection: 'Projection annuelle',
    grossRevenue: 'Revenu brut',
    grossRevenueTVAC: 'Revenu brut TVAC',
    yourAdditionalRevenue: 'Votre revenu additionnel',
    yourAdditionalRevenueTVAC: 'Votre revenu additionnel TVAC',
    recommendedPlan: 'Formule recommandée',
    bestForYourActivity: 'optimal pour votre activité',
    regularLabel: 'Standard',
    motivyaCommission: 'Commission Motivya',
    paymentFees: 'Frais de transaction',
    subscription: 'Abonnement',
    yourNetRevenue: 'Votre revenu additionnel',
    estimationNote: 'Estimation basée sur le seuil minimum atteint pour chaque séance',
    autoAdjustTitle: 'Abonnement auto-ajusté',
    autoUpgradeTitle: 'Upgrade automatique',
    noPrePaymentTitle: 'Pas de pré-paiement',
    popular: 'POPULAIRE',
    month: 'mois',
    choosePlan: 'Choisir',
    startFree: 'Commencer gratuitement',
    concreteExample: 'Exemple concret',
    guaranteedProfitable: 'Séance garantie rentable',
    commissionAndFees: 'Commission Motivya + frais de paiement 1,5%',
    monthlyProjection: 'Projection mensuelle',
    sessions: 'séances',
    insteadOf: 'au lieu de',
    asLongAsActive: 'Tant que vous êtes actif',
    // Journey Simulator
    interactiveSimulator: 'Simulateur Interactif',
    liveCoachExperience: 'Vivez l\'expérience coach',
    discoverHow: 'Découvrez comment fonctionne Motivya en 3 clics',
    createTestSession: 'Créer une séance test',
    clickMagic: 'Cliquez pour voir la magie opérer ✨',
    stepCreation: 'Création',
    stepPromotion: 'Promotion',
    stepBookings: 'Réservations',
    stepThreshold: 'Seuil atteint',
    stepPayment: 'Paiement',
    sessionCreatedMsg: '✨ Séance créée !',
    promotionInProgressMsg: '📣 Promotion en cours...',
    motivyaBroadcasts: 'Motivya diffuse votre séance aux sportifs de votre zone',
    registrationsArriving: '👥 Les inscriptions arrivent !',
    minParticipantsRequired: 'Seuil minimum : {count} participants',
    thresholdReachedMsg: '🎉 Seuil atteint !',
    sessionConfirmedMsg: 'Votre séance est confirmée',
    participantsEnrolled: '{count} participants inscrits',
    didNothingMsg: 'Vous n\'avez rien eu à faire !',
    paymentReceivedMsg: '💰 Paiement reçu !',
    regularCoach: 'Coach Active',
    ambassadorCoach: 'Coach Ambassadeur',
    ambassadorBadge: 'AMBASSADEUR',
    asAmbassadorBonus: 'en tant qu\'ambassadeur',
    invoicesAuto: 'Factures générées automatiquement',
    replayDemo: 'Rejouer la démo',
    sessionFlow: 'Séance réservée. Séance donnée. Séance payée.',
    focusPassion: 'Concentrez-vous sur votre passion, Motivya gère le reste.',
    // Hero section
    launchBadge: 'Lancement en cours',
    heroMainTitle: 'Devenez l\'un des',
    heroFoundingCoaches: '90 coachs fondateurs',
    heroInBrussels: 'à Bruxelles',
    heroSubtitle: 'Générez des revenus réguliers.',
    heroSubtitleBold: 'Sans risque. Sans salle.',
    // Opportunity section
    opportunitySectionTitle: 'Une opportunité réservée aux',
    opportunityFirstCoaches: 'premiers coachs',
    opportunityDesc: 'Les premiers coachs prennent les meilleurs créneaux et les meilleurs clients',
    maxVisibility: 'Visibilité maximale',
    maxVisibilityDesc: 'Dès le lancement, vous êtes en première ligne',
    priorityAccess: 'Accès prioritaire',
    priorityAccessDesc: 'Les premiers clients sont pour vous',
    localDomination: 'Domination locale',
    localDominationDesc: 'Devenez LA référence de votre quartier',
    // No risk model section
    uniqueModel: 'Modèle unique',
    noLossTitle: 'Le seul modèle où vous ne',
    noLossHighlight: 'perdez jamais',
    defineThreshold: 'Définissez votre seuil',
    defineThresholdDesc: 'Vous fixez le nombre minimum de participants requis',
    thresholdReached: 'Seuil atteint = Séance confirmée',
    thresholdReachedDesc: 'Vous êtes payé, vos participants sont confirmés',
    thresholdNotReached: 'Seuil non atteint = Annulation auto',
    thresholdNotReachedDesc: 'Pas de frais, pas de déplacement inutile',
    zeroLoss: 'Zéro perte',
    zeroLossDesc: 'Vous ne donnez jamais une séance à perte',
    exampleTitle: 'Exemple concret',
    pricePerPart: 'Prix par participant',
    grossRev: 'Revenu brut',
    commissionRange: 'Commission (10-30%)',
    paymentFeesEx: 'Frais de paiement (1,5%)',
    yourNetIncome: 'Votre revenu additionnel',
    guaranteedProfitableSession: 'Séance garantie rentable',
    monthlyProjectionLabel: 'Projection mensuelle (12 séances)',
    // Ambassador section
    exclusiveLaunch: 'Exclusif lancement',
    ambassadorStatus: 'Statut',
    coachAmbassadorTitle: 'Coach Ambassadeur',
    noRiskAdvantage: 'Vous ne prenez aucun risque. Vous prenez une avance.',
    // How it works section
    howItWorksTitle: 'Comment ça marche ?',
    step1Title: 'Créez votre profil',
    step1Desc: 'En 2 minutes, présentez vos spécialités et votre expérience',
    step2Title: 'Publiez vos séances',
    step2Desc: 'Définissez lieu, horaire, prix et seuil minimum',
    step3Title: 'Recevez vos participants',
    step3Desc: 'Les réservations arrivent, vous êtes payé automatiquement',
    // Pricing section
    choosePlanTitle: 'Choisissez votre formule',
    ambassadorAdvantages: 'Les coachs ambassadeurs',
    exclusiveAdvantages: 'bénéficient d\'avantages exclusifs',
    // Urgency section
    limitedOfferBadge: 'Offre limitée',
    ambassadorSpotsTitle: '90 places d\'ambassadeurs pour Bruxelles',
    commissionHalvedBenefit: 'commission divisée par 2',
    freemiumUnchanged: 'Le Freemium reste à 30% sans changement.',
    paymentFeesNote: '(+ frais de paiement 1,5%)',
    noAmbassadorFreemium: 'Le programme Ambassadeur n\'est pas disponible en Freemium. Choisissez Active ou Premium pour bénéficier de la commission réduite.',
    howItWorksButton: 'Comment ça marche ?',
    insteadOfPercent: 'au lieu de',
    reserveAmbassadorSpot: 'Réserver ma place d\'ambassadeur',
    // Final CTA section
    getAhead: 'Prenez une longueur d\'avance',
    rightNow: 'dès maintenant',
    joinTheCoaches: 'Rejoignez les {count} coachs qui ont déjà réservé leur place',
    becomeAmbassadorCoach: 'Devenir coach ambassadeur',
    freeSignup: 'Inscription gratuite • Sans engagement • Validation sous 48h',
    // Form section
    createYourProfile: 'Créez votre profil',
    remainingSpotsJoin: 'Rejoignez les {remaining} places restantes',
    // Already coach
    alreadyCoachTitle: 'Vous êtes déjà coach !',
    accessDashboard: 'Accédez à votre tableau de bord',
    goToDashboard: 'Accéder au dashboard',
    // Footer
    allRightsReserved: 'Tous droits réservés.',
    // Additional pricing keys
    publishSessions: 'Publier des séances',
    manageBookings: 'Gérer vos réservations',
    securePaymentFeature: 'Paiement sécurisé',
    basicStats: 'Statistiques de base',
    prioritySupport: 'Support prioritaire',
    searchVisibility: 'Visibilité boostée',
    premiumBadge: 'Badge Premium',
    advancedAnalytics: 'Statistiques avancées',
    startFree: 'Commencer gratuitement',
    chooseActive: 'Choisir Active',
    choosePremium: 'Choisir Premium',
    participants: 'participants',
    commissionAndFees: 'Commission Motivya + frais de paiement 1,5%',
    // Ambassador
    ambassadorProgram: 'Programme Coach Ambassadeur',
    applicationSent: 'Votre candidature a été envoyée !',
    commission: 'Commission',
    perSessionBonus: 'de plus par séance en tant qu\'ambassadeur',
    ambassadorAdvantageDesc: 'Commission réduite de moitié tant que vous êtes actif',
    sessions: 'séances',
    year: 'an',
    // LaunchCounter
    alreadyJoined: '{count} coachs ont déjà rejoint',
  },

  // Session Detail
  session: {
    bookNow: 'Réserver maintenant',
    viewDetails: 'Voir tous les détails',
    inviteFriends: 'Inviter des amis',
    spotsLeft: 'places restantes',
    full: 'Complet',
    duration: 'Durée',
    price: 'Prix',
    location: 'Lieu',
    date: 'Date',
    time: 'Heure',
    coach: 'Coach',
    level: 'Niveau',
    equipment: 'Équipement requis',
    indoor: 'Intérieur',
    outdoor: 'Extérieur',
  },

  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    login: 'Se connecter',
    yes: 'Oui',
    no: 'Non',
    back: 'Retour',
    next: 'Suivant',
    or: 'ou',
    and: 'et',
    sessions: 'séances',
    pers: 'pers.',
    min: 'min.',
  },

  // Date filters
  dates: {
    all: 'Toutes',
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    thisWeek: 'Cette semaine',
    thisWeekend: 'Ce weekend',
  },

  // Admin
  admin: {
    restrictedAccess: 'Acces restreint',
    loginToAccess: 'Connectez-vous pour accéder à l\'administration',
    login: 'Se connecter',
    administration: 'Administration',
    loggedIn: 'Connecté:',
    coachApplications: 'Candidatures Coach',
    manageApplications: 'Gérez les demandes de devenir coach sur Motivya',
    pending: 'En attente',
    approved: 'Approuvées',
    rejected: 'Refusées',
    all: 'Toutes',
    noApplications: 'Aucune candidature',
    noApplicationsPending: 'Aucune candidature en attente de validation',
    noApplicationsApproved: 'Aucune candidature approuvée',
    noApplicationsRejected: 'Aucune candidature refusée',
    submittedOn: 'Soumise le',
    yearsExp: 'ans d\'expérience',
    website: 'Site web',
    details: 'Détails',
    approve: 'Approuver',
    reject: 'Refuser',
    rejectionReason: 'Raison du refus',
    applicationDetails: 'Détails de la candidature',
    personalInfo: 'Informations personnelles',
    fullName: 'Nom complet',
    email: 'Email',
    professionalEmail: 'Email professionnel',
    phone: 'Téléphone',
    locationLabel: 'Localisation',
    externalLinks: 'Liens externes',
    linkedinProfile: 'Profil LinkedIn',
    professionalProfile: 'Profil professionnel',
    yearsOfExperience: 'Années d\'expérience',
    years: 'ans',
    bio: 'Bio',
    specialties: 'Spécialités',
    certifications: 'Certifications & Diplômes',
    motivation: 'Motivation',
    submittedAt: 'Soumise le:',
    reviewedAt: 'Traitée le:',
    rejectApplication: 'Refuser cette candidature',
    rejectionPlaceholder: 'Expliquez la raison du refus (obligatoire)...',
    confirmReject: 'Confirmer le refus',
    close: 'Fermer',
    toastUnauthorized: 'Accès non autorisé',
    toastLoadError: 'Erreur lors du chargement des candidatures',
    toastApproved: 'Candidature approuvée ! Le coach a été notifié.',
    toastApproveError: 'Erreur lors de l\'approbation',
    toastRejectReasonRequired: 'Veuillez indiquer une raison de refus',
    toastRejected: 'Candidature refusée. Le candidat a été notifié.',
    toastRejectError: 'Erreur lors du refus',
  },

  // Dashboard
  dashboard: {
    explore: 'Explorer',
    favorites: 'Favoris',
    admin: 'Admin',
    profile: 'Profil',
    hello: 'Bonjour,',
    subtitle: 'Gérez vos réservations et trouvez de nouvelles activités',
    findActivity: 'Trouver une activité',
    findActivityDesc: 'Découvrez les séances près de chez vous',
    myFavorites: 'Mes favoris',
    savedSessions: 'Séances sauvegardées',
    myProfile: 'Mon profil',
    myProfileDesc: 'Gérez vos informations personnelles',
    nearMe: 'Activités près de moi',
    geolocated: 'Géolocalisé',
    filters: 'Filtres',
    hide: 'Masquer',
    show: 'Afficher',
    category: 'Catégorie',
    searchRadius: 'Rayon de recherche:',
    sessionsFound: 'séances trouvées',
    inCategory: 'en',
    withinRadius: 'dans un rayon de',
    reset: 'Réinitialiser',
    locating: 'Recherche de votre position...',
    youAreHere: 'Vous êtes ici',
    sessionsAt: 'séances à',
    viewAll: 'Voir tout',
    upcomingSessions: 'Mes prochaines séances',
    noUpcoming: 'Aucune réservation à venir',
    findNext: 'Trouvez votre prochaine activité !',
    exploreSessions: 'Explorer les séances',
    confirmed: 'Confirmé',
    sessionValidated: 'Séance validée',
    spotLeft: 'place restante',
    spotsLeft: 'places restantes',
    viewDetails: 'Voir détails',
    history: 'Historique',
    cancelled: 'Annulées',
    cancelledSession: 'Séance annulée',
    refunded: 'Remboursé',
    cancelledBadge: 'Annulée',
    toastNotifNotSupported: 'Les notifications ne sont pas supportées par votre navigateur',
    toastNotifEnabled: 'Notifications activées !',
    toastNotifDenied: 'Notifications refusées',
    toastNotifDisabled: 'Notifications désactivées',
    toastNotifError: 'Erreur lors de l\'activation des notifications',
    confirmCancel: 'Êtes-vous sûr de vouloir annuler cette réservation ?',
    toastCancelled: 'Réservation annulée',
    toastCancelError: 'Erreur lors de l\'annulation',
    notifBody: 'Vous recevrez des notifications pour les nouvelles séances près de vous !',
  },

  // Favorites
  favorites: {
    loginRequired: 'Connectez-vous',
    loginToSee: 'pour voir vos favoris',
    login: 'Se connecter',
    title: 'Mes Favoris',
    sessionSaved: 'séance sauvegardée',
    sessionsSaved: 'séances sauvegardées',
    noFavorites: 'Aucun favori',
    noFavoritesDesc: 'Ajoutez des séances à vos favoris pour être notifié quand des places se libèrent !',
    exploreSessions: 'Explorer les séances',
    available: 'Places disponibles',
    fullWaiting: 'Complet - En attente',
    notifyWhenAvailable: 'Vous serez notifié dès qu\'une place se libère',
    full: 'Complet',
    spot: 'place',
    spots: 'places',
    bookNow: 'Réserver maintenant',
    notifEnabled: 'Notifications activées',
    notifDisabled: 'Notifications désactivées',
    removeFromFavorites: 'Retirer des favoris',
    toastRemoved: 'Retiré des favoris',
    toastRemoveError: 'Erreur lors de la suppression',
    toastLoadError: 'Erreur lors du chargement des favoris',
    toastUpdateError: 'Erreur lors de la mise à jour',
  },

  // Profile
  profile: {
    title: 'Mon Profil',
    subtitle: 'Gérez vos informations personnelles',
    coach: 'Coach',
    practitioner: 'Pratiquant',
    info: 'Informations',
    fullName: 'Nom complet',
    phone: 'Téléphone',
    city: 'Ville',
    cityPlaceholder: 'Ex: Bruxelles',
    becomeCoach: 'Devenir Coach',
    becomeCoachDesc: 'Vous êtes coach sportif ? Rejoignez notre communauté et proposez vos séances.',
    learnMore: 'En savoir plus',
    save: 'Enregistrer',
    toastSaved: 'Profil mis à jour !',
    toastSaveError: 'Erreur lors de la mise à jour',
    clickToChangePhoto: 'Cliquez sur la photo pour la modifier',
    photoUploaded: 'Photo téléchargée !',
    photoUploadError: 'Erreur lors du téléchargement',
    photoInvalidType: 'Format invalide. Utilisez JPEG, PNG ou WebP.',
    photoTooLarge: 'Photo trop volumineuse. Maximum 5MB.',
  },

  // Coach Dashboard
  coachDash: {
    calendar: 'Calendrier',
    hello: 'Bonjour,',
    coachSpace: 'Votre espace coach Motivya',
    newSession: 'Nouvelle séance',
    total: 'Total',
    sessionsCreated: 'Séances créées',
    upcoming: 'À venir',
    bookings: 'Réservations',
    totalRevenue: 'Revenus totaux',
    createSession: 'Créer une séance',
    publishActivity: 'Publiez une nouvelle activité',
    myCalendar: 'Mon calendrier',
    managePlanning: 'Gérez votre planning',
    myProfile: 'Mon profil',
    optimizeVisibility: 'Optimisez votre visibilité',
    recentSessions: 'Séances récentes',
    viewAll: 'Voir tout →',
    noSessions: 'Aucune séance créée',
    startFirst: 'Commencez par créer votre première séance',
    confirmed: 'Confirmé',
    pending: 'En attente',
    event: 'Événement',
    participants: 'participants',
    edit: 'Modifier',
    expiredSessions: 'Sessions expirées',
    noExpired: 'Aucune session expirée',
    noRevenue: 'Aucun revenu',
  },

  // Coach Calendar
  coachCal: {
    dashboard: 'Dashboard',
    title: 'Mon Calendrier',
    subtitle: 'Gérez vos séances programmées',
    newSession: 'Nouvelle séance',
    dayWithSession: 'Jour avec séance(s)',
    noSessionDay: 'Aucune séance ce jour',
    createForDate: 'Créez une nouvelle séance pour cette date',
    createSession: 'Créer une séance',
    confirmed: 'Confirmé',
    cancelled: 'Annulé',
    pending: 'En attente',
    edit: 'Modifier',
    allSessions: 'Toutes mes séances',
    noSessions: 'Aucune séance créée',
  },

  // Create Session
  createSession: {
    title: 'Nouvelle Séance',
    sessionType: 'Type de séance',
    regular: 'Séance régulière',
    regularDesc: 'Activité récurrente avec possibilité de répétition',
    uniqueEvent: 'Événement unique',
    uniqueEventDesc: 'Session ponctuelle, stage ou masterclass',
    generalInfo: 'Informations générales',
    sessionTitle: 'Titre de la séance *',
    titlePlaceholder: 'Ex: Yoga Vinyasa Flow Matinal',
    description: 'Description *',
    descriptionPlaceholder: 'Décrivez votre séance, son déroulement, ce que les participants vont apprendre...',
    category: 'Catégorie *',
    select: 'Sélectionner',
    level: 'Niveau *',
    dateTime: 'Date et horaires',
    startDate: 'Date de début *',
    startTime: 'Heure de début *',
    duration: 'Durée *',
    recurrence: 'Récurrence',
    unique: 'Unique',
    once: 'Une seule fois',
    daily: 'Quotidien',
    everyDay: 'Chaque jour',
    weekly: 'Hebdo',
    everyWeek: 'Chaque semaine',
    monthly: 'Mensuel',
    everyMonth: 'Chaque mois',
    occurrences: 'Nombre d\'occurrences',
    sessionsWillBeCreated: 'séances seront créées',
    consecutiveDays: 'jours consécutifs',
    weeks: 'semaines',
    months: 'mois',
    location: 'Lieu',
    searchAddress: 'Rechercher une adresse',
    addressPlaceholder: 'Ex: Parc du Cinquantenaire, Bruxelles',
    locationSelected: 'Lieu sélectionné',
    mapHint: 'Cliquez sur la carte ou faites glisser le marqueur pour ajuster la position',
    indoor: 'Séance en intérieur',
    indoorDesc: 'Activez si la séance a lieu en salle',
    participantsAndPricing: 'Participants et tarif',
    minimum: 'Minimum *',
    maximum: 'Maximum *',
    price: 'Prix (€) *',
    confirmationThreshold: 'Seuil de confirmation',
    equipment: 'Matériel requis (optionnel)',
    equipmentPlaceholder: 'Ex: Tapis de yoga, bouteille d\'eau',
    cancel: 'Annuler',
    createSessionBtn: 'Créer la séance',
    createMultiple: 'Créer {{count}} séances',
    toastDateRequired: 'Veuillez sélectionner une date',
    toastCategoryRequired: 'Veuillez sélectionner une catégorie',
    toastLocationRequired: 'Veuillez définir un lieu',
    toastCreatedMultiple: '{{count}} séances créées avec succès !',
    toastCreated: 'Séance créée avec succès !',
    toastError: 'Erreur lors de la création',
    dur30: '30 minutes',
    dur45: '45 minutes',
    dur60: '1 heure',
    dur90: '1h30',
    dur120: '2 heures',
  },

  // Edit Session
  editSession: {
    title: 'Modifier la séance',
    generalInfo: 'Informations générales',
    sessionTitle: 'Titre de la séance *',
    description: 'Description *',
    category: 'Catégorie *',
    level: 'Niveau *',
    dateTime: 'Date et horaires',
    date: 'Date *',
    startTime: 'Heure de début *',
    duration: 'Durée',
    location: 'Lieu',
    address: 'Adresse / Lieu *',
    indoor: 'Séance en intérieur',
    participantsAndPricing: 'Participants et tarif',
    minParticipants: 'Minimum de participants',
    maxParticipants: 'Maximum de participants',
    pricePerPerson: 'Prix par personne (€)',
    equipment: 'Matériel requis',
    cancelSession: 'Annuler la séance',
    back: 'Retour',
    save: 'Enregistrer',
    confirmed: 'Confirmé',
    cancelled: 'Annulé',
    pending: 'En attente',
    participants: 'participants',
    viewPage: 'Voir la page',
    enrolledParticipants: 'Participants inscrits',
    user: 'Utilisateur',
    select: 'Sélectionner',
    toastNotFound: 'Séance non trouvée',
    toastLoadError: 'Erreur de chargement',
    toastUpdated: 'Séance mise à jour !',
    toastUpdateError: 'Erreur lors de la mise à jour',
    confirmDelete: 'Êtes-vous sûr de vouloir annuler cette séance ? Tous les participants seront remboursés.',
    toastDeleted: 'Séance annulée',
    toastDeleteError: 'Erreur lors de l\'annulation',
    dur30: '30 minutes',
    dur45: '45 minutes',
    dur60: '1 heure',
    dur90: '1h30',
    dur120: '2 heures',
  },

  // Session Detail
  sessionDetail: {
    title: 'Détails de la séance',
    indoor: 'Indoor',
    outdoor: 'Outdoor',
    practicalInfo: 'Informations pratiques',
    minutes: 'minutes',
    viewOnMap: 'Voir sur la carte →',
    participants: 'participants',
    spotsLeft: 'place(s) restante(s)',
    full: 'Complet',
    minRequired: 'Minimum {{count}} participants requis',
    equipment: 'Matériel à apporter',
    yourCoach: 'Votre Coach',
    yearsExperience: 'ans d\'expérience',
    perPerson: 'par personne',
    sessionConfirmed: 'Séance confirmée',
    waitingParticipants: 'En attente de participants',
    youAreEnrolled: 'Vous êtes inscrit !',
    viewBookings: 'Voir mes réservations →',
    bookNow: 'Réserver maintenant',
    moreFunTogether: 'Cours plus fun à plusieurs !',
    securePayment: 'Paiement sécurisé - Annulation gratuite',
    loginToBook: 'pour réserver cette séance',
    toastNotFound: 'Séance non trouvée',
    toastLoadError: 'Erreur lors du chargement',
    toastLoginRequired: 'Connectez-vous pour réserver',
    toastCoachCannotBook: 'Les coachs ne peuvent pas réserver de séances',
    toastBooked: 'Réservation confirmée ! (Paiement simulé)',
    toastBookError: 'Erreur lors de la réservation',
  },

  // Coach Profile
  coachProfile: {
    title: 'Mon Profil Coach',
    subtitle: 'Complétez votre profil pour attirer plus de participants',
    fullName: 'Nom complet',
    phone: 'Téléphone',
    presentation: 'Présentation',
    bio: 'Bio',
    bioPlaceholder: 'Présentez-vous, votre parcours, votre approche...',
    specialties: 'Spécialités',
    certifications: 'Certifications',
    addCert: 'Ajouter',
    certPrompt: 'Nom de la certification:',
    experienceAndRates: 'Expérience et tarifs',
    yearsExperience: 'Années d\'expérience',
    hourlyRate: 'Tarif horaire indicatif (€)',
    serviceArea: 'Zone d\'intervention',
    serviceAreaPlaceholder: 'Ex: Bruxelles et environs',
    save: 'Enregistrer',
    toastSaved: 'Profil mis à jour !',
    toastError: 'Erreur lors de la mise à jour',
  },

  // Auth
  auth: {
    loginTitle: 'Connexion',
    registerTitle: 'Créer un compte',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    name: 'Nom complet',
    loginBtn: 'Se connecter',
    registerBtn: 'S\'inscrire',
    googleLogin: 'Continuer avec Google',
    noAccount: 'Pas encore de compte ?',
    hasAccount: 'Déjà un compte ?',
    signUp: 'S\'inscrire',
    signIn: 'Se connecter',
    loginFirst: 'Veuillez vous connecter d\'abord',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    registerSuccess: 'Inscription réussie !',
    completeCoachProfile: 'Complétez votre fiche de renseignement pour devenir coach',
    backToHome: 'Retour à l\'accueil',
    joinAs: 'Je souhaite rejoindre en tant que',
    practitioner: 'Pratiquant',
    practitionerDesc: 'Je veux participer à des séances sportives',
    coachOption: 'Coach',
    coachDesc: 'Je veux proposer des séances',
  },
  // WhatsApp
  whatsapp: {
    inviteFriends: 'Inviter des amis',
    bookingConfirmed: 'Réservation confirmée !',
    spotsLeftInvite: 'Il reste {{count}} place(s) - Invitez vos amis !',
    shareSession: 'Partagez cette séance avec vos amis',
    shareOnWhatsApp: 'Partager sur WhatsApp',
    maybeLater: 'Peut-être plus tard',
    msgBooked: 'Je viens de réserver un cours de sport !',
    msgSpotsLeft: 'Il reste {{count}} place(s) ! Qui vient avec moi ?',
    msgBookSpot: 'Réserve ta place',
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié !',
    inviteTitle: 'Invitez un ami',
    inviteDesc: 'Je participe à cette activité sportive sur Motivya. Tu viens avec moi ?',
  },

  // Share (multi-platform)
  share: {
    inviteFriend: 'Inviter un ami',
    shareVia: 'Partager via',
    spotsLeft: '{{count}} places restantes',
    spotsLeftMessage: 'Plus que {{count}} place(s) !',
    bookYourSpot: 'Réserve ta place',
    copied: 'Copié !',
    copyLink: 'Copier le lien',
    justBooked: 'Je viens de réserver !',
    bookingConfirmed: 'Réservation confirmée !',
    spotsLeftInvite: 'Il reste {{count}} places, invite tes amis !',
    shareWithFriends: 'Partage cette séance avec tes amis !',
    shareWhatsApp: 'Partager sur WhatsApp',
    moreOptions: "Plus d'options de partage",
    maybeLater: 'Plus tard',
  },

};

export default fr;
